import { useCallback, useEffect, useState } from 'react';

import { getAllBusinessUnits, getAllOperations, typeUbicationSS } from '../services/yclickMaster';

import useToast from './useToast';

const useGetParamsForWorkReportTemplate = ({ permissions }) => {
  const [paramsLocation, setParamsLocation] = useState({
    optionsUbicationType: [],
    optionsOperations: [],
    filteredOperations: [],
    filteredBusinessUnits: [],
    optionsBusinessOptions: [],
    disabledChangeUunn: false
  });

  const { setNewToast } = useToast();

  const setBusinessUnitsAndOperationsAvailables = ({ businessUnitsIds, operationIds }) => {
    const operationIdsSelecteds = paramsLocation.optionsOperations.filter((operation) =>
      operationIds.includes(operation.id)
    );

    const businessUnitsIdsSelecteds = paramsLocation.optionsBusinessOptions.filter((businessUnit) =>
      businessUnitsIds.includes(businessUnit.id)
    );

    setParamsLocation({
      ...paramsLocation,
      filteredOperations: operationIdsSelecteds,
      filteredBusinessUnits: businessUnitsIdsSelecteds,
      disabledChangeUunn: true
    });
  };

  const getParams = useCallback(async () => {
    if (permissions) {
      try {
        const includeGenericTypes = true;
        const responseUbicationType = await typeUbicationSS(includeGenericTypes);
        const responseBusinessUnits = await getAllBusinessUnits();
        const responseOperations = await getAllOperations();

        setParamsLocation({
          optionsUbicationType: responseUbicationType,
          optionsOperations: responseOperations,
          optionsBusinessOptions: responseBusinessUnits,
          disabledChangeUunn: false
        });
      } catch (err) {
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      }
    }
  }, [permissions, setNewToast]);

  useEffect(() => {
    getParams();
  }, [permissions, getParams]);

  return { paramsLocation, setBusinessUnitsAndOperationsAvailables };
};

export default useGetParamsForWorkReportTemplate;
